import { memo } from "react";
import { useSelector } from "react-redux";
import Squawk from "@cbc/macaw";
import ErrorBoundary from "../ErrorBoundary/component";
import AdContainer from "../../stories/Components/AdContainer";

const isMycbc = (dept) => dept.slug === "mycbc";

const WrappedSquawk = (props) => {
    const gdpr = useSelector((state) => state.gdpr);
    const pageType = useSelector((state) => state.app.pageType);
    const hierarchy = useSelector((state) => state.app.ad_hierarchy);
    const adOrder = useSelector((state) => state.app.adOrder);
    const pagePath = useSelector((state) => state.app.path);
    const pageSection = useSelector((state) => state.app.baseSection);
    const dept = useSelector((state) => state.detail.content.departments);
    const adTestGroup = useSelector((state) => state.page.adTestGroup);

    const squawkProps = {
        unmounted: true,
        gdpr,
        hierarchy,
        pageData: { pageType, pagePath, pageSection },
        deptData: { dept },
        ...props,
        targeting: { bu: "feed", ...props.targeting },
        adTestGroup: pagePath === "news/canada" ? adTestGroup : undefined,
    };

    if (dept?.some(isMycbc)) {
        return null;
    }

    if (gdpr.euCountry === true) {
        return null;
    }

    if (
        pagePath !== undefined &&
        pagePath.includes("player/play") &&
        typeof adOrder === "string" &&
        adOrder === ""
    ) {
        return null;
    }

    if (pagePath === "news/canada") {
        if (adTestGroup === "B" || adTestGroup === "C") {
            if (props.type.includes("bigbox")) {
                return null;
            }
            if (props.type === "risingstar" && adTestGroup === "C") {
                return null;
            }
        }
    }

    const containerClassNames =
        props.type === "bigbox-fixed" || props.type === "bigbox-sticky"
            ? "bigBoxContainer fixedBigBoxContainer"
            : "bigBoxContainer";

    return (
        <ErrorBoundary
            beforeCapture={(scope) => {
                scope.setTag("component", "@cbc/macaw");
            }}
        >
            {props.type === "bigbox" ||
            props.type === "bigbox-single" ||
            props.type === "bigbox-double" ||
            props.type === "bigbox-sticky" ||
            props.type === "bigbox-fixed" ? (
                <div
                    className={containerClassNames}
                    data-testid={`${props.type}-ad`}
                >
                    <AdContainer
                        type={props.type}
                        adContainerClasses={props.adContainerClasses}
                    >
                        <Squawk {...squawkProps} />
                    </AdContainer>
                </div>
            ) : (
                <AdContainer
                    type={props.type}
                    adContainerClasses={props.adContainerClasses}
                >
                    <Squawk {...squawkProps} />
                </AdContainer>
            )}
        </ErrorBoundary>
    );
};

export default memo(WrappedSquawk);
